/**
 * Ghép số liệu 2 kỳ của cùng một nhóm để vẽ biểu đồ + bảng so sánh.
 *
 * Backend trả về mỗi nhóm dạng [{ Ten, SoLuong, ThuTu }] và 2 kỳ có thể không
 * cùng danh sách nhóm (VD: kỳ trước có "Nông dân" mà kỳ này không), nên phải
 * hợp nhất theo tên và điền 0 cho phần thiếu — nhóm chỉ có ở kỳ so sánh vẫn
 * được thống kê đầy đủ.
 *
 * Sắp xếp lại theo đúng thứ tự backend dùng (ThuTu nghiệp vụ -> số lượng giảm
 * dần -> tên) để nhóm chỉ có ở kỳ so sánh nằm đúng chỗ thay vì bị dồn xuống
 * cuối bảng (VD: biểu đồ độ tuổi phải giữ thứ tự Dưới 25 -> 25-35 -> ... và
 * "Chưa xác định" luôn đứng cuối).
 */
const THU_TU_CUOI = 9;

export const ghepDuLieuSoSanh = (dsKyNay, dsKyTruoc) => {
  const map = new Map();

  const gop = (item, khoaKy) => {
    if (!item) return;
    const cu = map.get(item.Ten);
    if (cu) {
      cu[khoaKy] = item.SoLuong || 0;
      // Kỳ nào cũng trả về cùng ThuTu cho một nhóm; giữ giá trị đã có
      if (cu.thuTu === undefined) cu.thuTu = item.ThuTu;
    } else {
      map.set(item.Ten, {
        ten: item.Ten,
        kyNay: 0,
        kyTruoc: 0,
        thuTu: item.ThuTu,
        [khoaKy]: item.SoLuong || 0,
      });
    }
  };

  (dsKyNay || []).forEach((item) => gop(item, "kyNay"));
  (dsKyTruoc || []).forEach((item) => gop(item, "kyTruoc"));

  // Backend cũ chưa trả ThuTu: đẩy "Chưa xác định" xuống cuối, còn lại giữ nguyên
  const thuTuCua = (item) =>
    item.thuTu !== undefined && item.thuTu !== null
      ? item.thuTu
      : item.ten === "Chưa xác định"
        ? THU_TU_CUOI
        : 1;

  return Array.from(map.values()).sort(
    (a, b) =>
      thuTuCua(a) - thuTuCua(b) ||
      b.kyNay - a.kyNay ||
      b.kyTruoc - a.kyTruoc ||
      a.ten.localeCompare(b.ten)
  );
};
